const AchTransactionTypes: any = {
  ACH_DEBIT: 'ACH Debit',
  ACH_CREDIT: 'ACH Credit',
  BILL_PAY: 'Bill Pay',
  ACH_DEBIT_OR_ACH_CREDIT: 'ACH Debit or ACH Credit',
  ACH_DEBIT_OR_BILL_PAY: 'ACH Debit or Bill Pay',
  ACH_CREDIT_OR_BILL_PAY: 'ACH Credit or Bill Pay',
  ACH_DEBIT_OR_ACH_CREDIT_OR_BILL_PAY: 'ACH Debit or ACH Credit or Bill Pay',
};

export default AchTransactionTypes;
